module.exports = __webpack_public_path__ + "static/mobile-2ed7e1ee8d8a0928fee4f82bc7d55aec.png";